import { createStore } from 'vuex'

export default createStore({
  state: {
    locale: localStorage.getItem('locale') || 'zh-CN', // 当前语言设置
    menuData: {
      newsSubItems: [],
      productSubItems: [],
      isLoaded: false ,
      navItems: []  //  统一的导航数据
    }
  },
  getters: {
    currentLocale: state => state.locale,
    getMenuData: state => state.menuData,
    getNavItems: state => state.menuData.navItems
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale;
      localStorage.setItem('locale', locale); // 保存到本地存储
    },
    SET_MENU_DATA(state, { newsSubItems, productSubItems }) {
      state.menuData.newsSubItems = newsSubItems;
      state.menuData.productSubItems = productSubItems;
      state.menuData.isLoaded = true;
    },
    SET_NAV_ITEMS(state, navItems) {
      state.menuData.navItems = navItems;
    },
    CLEAR_MENU_DATA(state) {
      state.menuData.newsSubItems = [];
      state.menuData.productSubItems = [];
      state.menuData.isLoaded = false;
    }
  },
  actions: {
    changeLocale({ commit }, locale) {
      commit('SET_LOCALE', locale);
    },
    async loadMenuData({ commit, state }, { getSimpleListApi }) {
      if (!state.menuData.isLoaded) {
        try {
          const newsRes = await getSimpleListApi({ type: 5 });
          const productRes = await getSimpleListApi({ type: 6 });
          
          let newsSubItems = [];
          newsRes.data.forEach(item => {
            newsSubItems.push({ title: item.name, href: '/newsConsultation?type=' + item.id });
          });
          
          let productSubItems = [];
          productRes.data.forEach(item => {
            productSubItems.push({ title: item.name, href: '/productDisplay?type=' + item.id });
          });
          
          commit('SET_MENU_DATA', { newsSubItems, productSubItems });
          
          return { newsSubItems, productSubItems };
        } catch (error) {
          console.error('Error loading menu data:', error);
          throw error;
        }
      } else {
        // 如果数据已加载，直接返回现有数据
        return {
          newsSubItems: state.menuData.newsSubItems,
          productSubItems: state.menuData.productSubItems
        };
      }
    }
  },
  modules: {
  }
})
